import React from "react";

export default function Footer({CapitalSocial, CompteBancaire, NIF, total}) {
    var writtenNumber = require("written-number");
    return (
        <div style={{marginTop: "240px", alignSelf: "end"}}>

            <div className="items-end justify-end">
                <h3 className="flex flex-row items-end justify-end text-gray-800 text-2xl font-semibold">
                    Total TTC:{" "}
                    <p className="text-gray-800 ml-2 text-xl font-bold">
                        {" "}
                        {total.toLocaleString()}.00 Da
                    </p>
                </h3>
            </div>
            <p className="uppercase text-md border-solid border-2 border-black m-2">
                {writtenNumber(total, {lang: "fr"})} dinar algérien
            </p>
            <footer className="footer bottom-0 border-t-2 border-gray-300 pt-5">
                <div className="flex flex-row items-center justify-center">
                    <p className="font-medium text-sm text-center">
                        CapitalSocial: {CapitalSocial} CompteBancaire: {CompteBancaire} NIF:{" "}
                        {NIF}
                    </p>
                </div>
            </footer>
        </div>
    );
}
